import React from 'react';
import { compose,  head } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './engineDatepicker.js';
import Datepicker from '@synergycms_core/components/generic/Datepicker';
import { connect } from 'react-redux';
import RichText from '@synergycms_core/components/generic/RichText';
import TooltipWrapper from '@synergycms_core/components/generic/TooltipWrapper';
import Price from '@synergycms_core/components/generic/Price';
import { Map, List } from 'immutable';
import { parseRestriccions } from './engineUtils';
import { formatCurrencyAmount } from '@synergycms_core/utils/utils';
import { enableCachePrices } from "@synergycms_core/store/app/utils";
import { showPopover } from '../../providers/popoverProvider.jsx';
class engineDatepickerDay extends React.Component {
  static displayName = 'EngineDatepickerDay';

  
  render() {
    const { config, theme } = this.props;
    const { classes } = theme.styles;
    const { day, data, validCurrency } = config;
    const price = !!day && !!data && data.price_tax;
    const hasRestricccions = data && data.applied_restrictions && !!data.applied_restrictions.length;
    const disableTooltip = !day || !hasRestricccions;
    const cx = theme.bind();
    return (
      <div className={[classes.dayContainer, cx({priceWithRestriction: hasRestricccions && !!day})].join(' ')}>
        <TooltipWrapper
          enablePropagation={true}
          autoCloseTimeout={6000}
          family={"EngineDatepickerTooltip"}
          typeTooltip={!!day && "tooltipDay" + day.format("D")}
          disabled={disableTooltip}
          removeTooltipTimeout={0}
          popoverStyle={[classes.tooltipCalendar,!hasRestricccions && classes.displacedCloseButton].join(' ')}
          popover={(toogleTooltip, forceCloseTooltip) => {
            return (<div className={classes.restrictionContainer}>
              {hasRestricccions &&
                <RichText translate={true} ucFirst={true} withVars={head(data.applied_restrictions)} text={parseRestriccions(head(data.applied_restrictions).type)} />
              }
            </div>);
          }}
          posX={'middle'}
          posY={'top'}
        >
          <div>
            <RichText text={!!day && day.format("D")} innerStyle={[classes.dayText, (!day && classes.noDispoDayText)]} />
            {price && <Price innerStyle={[classes.priceText, data.bestPrice && classes.bestPrice]} amount={price} hideDecimals={true} forceSymbol={true} hideSymbol={!validCurrency} formatPrice={!validCurrency} tabIndex={0}/>}
          </div>
        </TooltipWrapper>
      </div>
    );
  }
}

const EngineDatepickerDay = compose(
  PropertyManager(["day", "stringDate", "isSelected", "startRange", "endRange", "disabled", "data", "parsePrice", "finalCurrency", "validCurrency"]),
  withThemeJSS({ styleFile, link: true })
)(engineDatepickerDay)

class EngineDatepicker extends React.Component {
  static displayName = 'EngineDatepicker';
  render() {
    const { config, theme } = this.props,
      {
        finalCurrency,
        parsePrice,
        validCurrency
      } = config;
    const { classes } = theme.styles;
    const cx = theme.bind();
    return (
      <div  className={[theme.computedInnerStyle, cx({engineDatepickerContainer:theme.deviceType !== 'MOBIL' && config.prices})].join(' ')}>
        <Datepicker
          onRangeChange={(dates) => {
            if (dates.start && dates.end) {
              config.closeByFamily("EngineDatepickerTooltip");
            }
            config.onRangeChange(dates);
          }}
          onScroll={()=>{
              config.closeByFamily("EngineDatepickerTooltip");
          }}
          start={config.start}
          end={config.end}
          months={config.months}
          dayTemplate={config.prices && ((day) => {
            return <EngineDatepickerDay
              config={day}
              data={config.prices[day.stringDate]}
              finalCurrency={finalCurrency}
              parsePrice={parsePrice}
              validCurrency={validCurrency} />;
          })}
          onChangeCalendar={config.onChangeCalendar}
          minDate={config.minDate}
          inOpen={config.inOpen}
        />
        {config.prices &&
          <div className={classes.aclarationDatepickerTextContainer}>
            {validCurrency ? 
              <RichText
                innerStyle={classes.aclarationDatepickerText}
                ucFirst={true}
                translate={true}
                text={'_%* Precios aproximados para 2 personas.%_'}
              /> :
              <>
                <RichText
                  innerStyle={classes.aclarationDatepickerText}
                  ucFirst={true}
                  translate={true}
                  text={'_%* Precios aproximados en%_'}
                />
                {' '}
                <RichText
                  innerStyle={classes.aclarationDatepickerText}
                  ucFirst={true}
                  translate={true}
                  text={finalCurrency.get("code")}
                />
                {' '}
                <RichText
                  innerStyle={classes.aclarationDatepickerText}
                  translate={true}
                  text={'_%para 2 personas.%_'}
                />
              </>
            }
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = (store, ownProps) => {
  let data = Map();
  const params = store.getIn(["customer", "params", "avail_cache_params"],Map());
  const availQuery = store.getIn(["customer", "params", "avail_cache_query_params"]);
  //store.getIn(['availCache', params.get("hotelId") || store.get("group"), availQuery]);
  const currentCurrencyCode = store.getIn(['customer', 'current_currency']) || undefined;
  const validCurrency = (["EUR", "USD", "GBP"]).includes(currentCurrencyCode);
  //const outerWeb = store.getIn(["app", "outer_web"]);

  data = enableCachePrices(store) && store.getIn(['availCache', params.get("hotelId") || store.get("group"), availQuery]);
  const currencies = store.getIn(['customer', 'currencies'], List());
  return {
    //currency: store.getIn(["hotels", "hotels_info", "hotels"]).find(hotel => hotel.get("id") == data.first().get("hotel_id")).get("code"),
    prices: (data && data.toJS()) || undefined,
    finalCurrency: currencies.find(c => c.get('code') === currentCurrencyCode),
    parsePrice: formatCurrencyAmount(currencies, currentCurrencyCode, store.getIn(['customer', 'lang_info'])),
    validCurrency:validCurrency
  };
};

//onRangeChange={this.updateRange}
//start={start}
//end={end}
//months={2}

export default compose(
  connect(mapStateToProps),
  showPopover,
  PropertyManager(['onRangeChange', 'start', 'end', 'months', 'prices', 'onChangeCalendar', 'minDate', 'inOpen', 'parsePrice', 'finalCurrency', 'closeByFamily', 'validCurrency']),
  withThemeJSS({ styleFile, link: true })
)(EngineDatepicker);
